export enum PreCheckAnswer {
  OK = 'ok',
  DEFECT_FOUND = 'Defect found',
  NOT_APPLICABLE = 'n/a',
}
